export default "__VITE_ASSET__D3Nmp$k$__"